/* Café 1715 — révélation des éléments au scroll (façon lamarzocco.com).
   Cible les composants cafe-* ; cascade par section ; opacity/transform only.
   L'état initial masqué est posé par cafe.css sous html.cafe-anim (ajouté
   inline dans theme.liquid), avec un failsafe qui révèle tout après 3 s si ce
   script n'a pas démarré. Résilient à l'hydratation Savor (remplacement de
   nœuds après le premier rendu) : dédup WeakSet + ré-init après load. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) {
    document.documentElement.classList.add('cafe-anim-failsafe');
    return;
  }

  var SELECTORS = [
    '.cafe-hero__eyebrow', '.cafe-hero__title', '.cafe-hero__body', '.cafe-hero__cta',
    '.cafe-eyebrow', '.cafe-h2',
    '.cafe-pillar', '.cafe-card', '.cafe-post',
    '.cafe-feature__media', '.cafe-feature__content',
    '.cafe-fiche', '.cafe-wheel', '.cafe-aroma__side',
    '.cafe-guide__rte', '.cafe-faq__item',
    '.cafe-mopts', '.cafe-specs-wrap', '.cafe-tabs__nav',
    '.cafe-quote-form', '.cafe-authority__logos', '.cafe-reassurance__item',
    '.cafe-collhead__inner > *'
  ].join(',');

  var seen = new WeakSet();

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

  function init() {
    window.__cafeRevealOK = true;
    var els = document.querySelectorAll(SELECTORS);
    var groups = new Map();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      if (seen.has(el) || el.classList.contains('is-revealed')) return;
      seen.add(el);
      var group = el.closest('.cafe-section, .cafe-hero, section, main') || document.body;
      var i = groups.get(group) || 0;
      groups.set(group, i + 1);
      el.style.setProperty('--reveal-delay', Math.min(i, 5) * 90 + 'ms');
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) {
        // Déjà visible au chargement : révélation par TIMER, pas par rAF/IO —
        // les rendering steps (donc rAF et callbacks IO) restent gelés tant que
        // le render-blocking des view-transitions Savor n'est pas levé, alors
        // que les timers tournent. La classe est posée pendant le gel ; la
        // transition se joue à la reprise du rendu.
        setTimeout(function () { el.classList.add('is-revealed'); }, 60);
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  // L'hydratation Savor (section-renderer/morph) remplace des nœuds à des
  // moments imprévisibles : on ré-initialise à chaque mutation du main,
  // débouncé. childList seulement → les ajouts de classes/styles faits par
  // init ne re-déclenchent pas l'observer (pas de boucle).
  var moTimer = null;
  var mo = new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(init, 120);
  });
  function watch() {
    // body : jamais remplacé par l'hydratation (contrairement à #MainContent)
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
